import { ReportsFilters } from 'contexts/ReportsFiltersContext';

export const REPORTS_FILTERS_NAME: Record<string, keyof ReportsFilters> = {
  FROM_DATE: 'since',
  TO_DATE: 'until',
  EVENT: 'event',
  PRODUCT: 'products',
  LOT_CODE: 'lotCode',
  REF_DOC_TYPE: 'refDocType',
  REF_DOC_NUMBER: 'refDocNumber',
};
